import TopHeader from './TopHeader';
import Main from './Main';
import ContainerLayout from './ContainerLayout';
import { Spinner } from '@amzn/awsui-components-react';
import Footer from './Footer';
import React from 'react';
import { AppConfig } from '../types/app';
import { PostAuthComponent } from '../pages/AuthResponse';

export const AuthResponseSpinner = ({
  config,
  postAuthFlows,
  flowIndex,
}: {
  config: AppConfig;
  postAuthFlows: PostAuthComponent[];
  flowIndex: number;
}) => {
  return (
    <>
      {' '}
      <TopHeader config={config} />
      <Main config={config}>
        <ContainerLayout currentPostAuthFlow={postAuthFlows[flowIndex].type}>
          <Spinner size="large" data-testid="spinner" />{' '}
        </ContainerLayout>
      </Main>
      <Footer enableCookieComponent={config.enableCookieComponent === 'true'} />
    </>
  );
};
